import React from 'react';
import { Card, Empty } from 'antd';

/** 托盘运输（LTL/FTL/海运/空运）报价与购买——占位，等接入具体货运 Gateway 后再实现。 */
const PalletRateQuote: React.FC = () => (
  <Card>
    <Empty description="托盘运输报价即将上线" />
  </Card>
);

export default PalletRateQuote;
